/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityMappingResult } from './ControlEntityMappingResult';
import {
    ControlEntityMappingResultFromJSON,
    ControlEntityMappingResultFromJSONTyped,
    ControlEntityMappingResultToJSON,
} from './ControlEntityMappingResult';

/**
 * 
 * @export
 * @interface ControlEntityMappingResponse
 */
export interface ControlEntityMappingResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityMappingResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityMappingResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityMappingResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityMappingResult>}
     * @memberof ControlEntityMappingResponse
     */
    results?: Array<ControlEntityMappingResult>;
}

/**
 * Check if a given object implements the ControlEntityMappingResponse interface.
 */
export function instanceOfControlEntityMappingResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityMappingResponseFromJSON(json: any): ControlEntityMappingResponse {
    return ControlEntityMappingResponseFromJSONTyped(json, false);
}

export function ControlEntityMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityMappingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityMappingResultFromJSON)),
    };
}

export function ControlEntityMappingResponseToJSON(value?: ControlEntityMappingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityMappingResultToJSON)),
    };
}

